import { DonorSourceCategory } from '../generated/enums.gen';

export const DONOR_SOURCE_CATEGORY_LABELS: Readonly<Record<DonorSourceCategory, string>> = {
  [DonorSourceCategory.CasinoLicensee]: 'Casino licensee or affiliate',
  [DonorSourceCategory.RegulatedCorporation]: 'Bank, insurer, utility or other regulated company',
  [DonorSourceCategory.ForeignNational]: 'Foreign national',
  [DonorSourceCategory.Anonymous]: 'Anonymous or fictitious name',
};

export function donorSourceCategoryLabel(category: DonorSourceCategory): string {
  return DONOR_SOURCE_CATEGORY_LABELS[category] ?? category;
}
